module.exports = __webpack_public_path__ + "static/media/illustration-section-02.09cdb6b6.svg";